import React, { useState } from 'react';
import { Grid } from '../../common/layouts/Grid';
import { Button } from '../../common/components/Button';
import { Icon } from '../../common/components/Icon';
import { Alert } from '../../common/components/Alert';
import StandardModal from '../../common/modals/StandardModal';
import TAP from '../../../models/entities/TAP';
import { authenticatedUser } from '../../../authentication/authModule';

interface TAPDelegatedProps {
    tap: any;
    handleRejectTAP: any;
    loading: boolean;
}

const TAPDelegated = ({ tap, handleRejectTAP, loading }: TAPDelegatedProps) => {
    const [cancelDelegateModalVisible, setCancelDelegateModalVisible] = useState(false);

    const handleCancel = () => {
        setCancelDelegateModalVisible(false);
    };

    const handleConfirm = () => {
        handleRejectTAP(tap.id);
        setCancelDelegateModalVisible(false);
    };

    return (
        <>
            <Button
                style={{ zIndex: 0, cursor: 'pointer' }}
                variant="primary"
                size="small"
                onClick={() => setCancelDelegateModalVisible(true)}
                disabled={loading || tap.delegatedStatus === 'Disabled' || authenticatedUser.userId === tap.delegated?.id}
            >
                <Icon icon="trashcan" size="small" />
            </Button>
            <StandardModal
                show={cancelDelegateModalVisible}
                onDismiss={handleCancel}
                title="Cancel Delegation"
                footer={
                    <Grid variant="2up">
                        <Grid.Item>
                            <Button variant="secondary" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Grid.Item>
                        <Grid.Item>
                            <Button variant="primary" onClick={handleConfirm} disabled={loading}>
                                Confirm
                            </Button>
                        </Grid.Item>
                    </Grid>
                }
            >
                <Alert
                    variant="warning"
                    body="Are you sure you want to cancel the delegation? This action cannot be undone."
                />
            </StandardModal>
        </>
    );
};

export default TAPDelegated;
